import type { RouteObject } from 'react-router';

import { registerEditorialBlocks } from '../_shared/blocks';
import { EditorialEditPage } from './EditorialEdit';

/** The authoring surface. Two of the five states reach it; the rest meet a door. */
registerEditorialBlocks();

export const editorialEditRoute: RouteObject = {
  path: 'editorial/:postId/edit',
  element: <EditorialEditPage />,
};
